import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { Close, Menu } from '@mui/icons-material';
import {
	Box,
	Divider,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	Tab,
	Tabs,
} from '@mui/material';

import { UserRole } from '../../../../server/src/shared/user-roles';
import { useUser } from '../../utils/user-provider';
import { Me } from './me';

const navMessages = defineMessages({
	devices: { id: 'nav.devices', defaultMessage: 'Zařízení' },
	dashboard: { id: 'nav.dashboard', defaultMessage: 'Dashboard' },
	users: { id: 'nav.users', defaultMessage: 'Uživatelé' },
	groups: { id: 'nav.groups', defaultMessage: 'Skupiny' },
	partner: { id: 'nav.partner', defaultMessage: 'Partnerská sekce' },
	client: { id: 'nav.client', defaultMessage: 'Klientská sekce' },
	deviceUpdates: { id: 'nav.deviceUpdates', defaultMessage: 'Aktualizace zařízení' },
});

export const Nav = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const user = useUser();
	const intl = useIntl();

	const [drawerIsOpen, setDrawerIsOpen] = useState(false);

	const isAdmin = user?.role === UserRole.ADMIN;
	const hasGroups = Boolean(user?.groups.length);

	const items = [
		{ label: intl.formatMessage(navMessages.devices), link: '/', show: true },
		{ label: intl.formatMessage(navMessages.dashboard), link: '/dashboard', show: hasGroups || isAdmin },
		{ label: intl.formatMessage(navMessages.users), link: '/users', show: isAdmin },
		{ label: intl.formatMessage(navMessages.groups), link: '/groups', show: isAdmin },
		{ label: intl.formatMessage(navMessages.partner), link: '/partner', show: hasGroups },
		{ label: intl.formatMessage(navMessages.client), link: '/client', show: !hasGroups },
		{
			label: intl.formatMessage(navMessages.deviceUpdates),
			link: '/devices/updates',
			show: hasGroups || isAdmin,
		},
	];

	return (
		<>
			<Box sx={{ borderBottom: 1, borderColor: 'divider', display: { xs: 'none', md: 'block' } }}>
				<Tabs value={pathname} onChange={(_e, link) => navigate(link)}>
					{items
						.filter((item) => item.show)
						.map((item) => (
							<Tab key={item.link} label={item.label} value={item.link} />
						))}
				</Tabs>
			</Box>

			<Box sx={{ display: { xs: 'block', md: 'none' } }} onClick={() => setDrawerIsOpen(true)}>
				<IconButton>
					{drawerIsOpen ? <Close sx={{ fontSize: 26 }} /> : <Menu sx={{ fontSize: 26 }} />}
				</IconButton>
			</Box>

			<Drawer open={drawerIsOpen} onClose={() => setDrawerIsOpen(false)}>
				<List sx={{ minWidth: 240 }}>
					{items
						.filter((item) => item.show)
						.map(({ link, label }) => (
							<ListItem key={link} disablePadding>
								<ListItemButton
									selected={pathname === link}
									onClick={() => {
										navigate(link);
										setDrawerIsOpen(false);
									}}
								>
									<ListItemText primary={label} />
								</ListItemButton>
							</ListItem>
						))}
				</List>
				<Me sx={{ mt: 'auto' }} />
			</Drawer>
		</>
	);
};
